import { formatCurrency } from "@habity/utils";

// FIXME: Not properly currency formatted
// Need to figure out how to do range formatting gracefully
export function getPriceRange(
  min: number | null,
  max: number | null, 
) {
  if (min && max) {
    if (min === max) return `${formatCurrency(min)}`
    return `${formatCurrency(min)} - ${formatCurrency(max)}`
  }
  if (min) {
    return `Från ${formatCurrency(min)}`
  }
  if (max) {
    return `Upp till ${formatCurrency(max)}`
  }

  return "";
}
